import { Fragment } from 'react'
import { useRouter } from 'next/navigation'
import { signOut, useSession } from 'next-auth/react'
import { Dialog, Transition } from '@headlessui/react'
import { closeApiSession } from './action'

export const CloseSessionModal = ({ isOpen, closeModal }) => {
  const router = useRouter()
  const { data: session } = useSession()

  const handleClick = async () => {
    await closeApiSession(session)
    signOut({ redirect: false, callbackUrl: '/' }).then(() => {
      router.push('/api/auth/signin')
    })
  }

  return (
    <>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="bg-black/50 dark:bg-gray-darkMode/75 fixed inset-0" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex items-center justify-center min-h-full p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="rounded-2xl dark:bg-black-darkMode flex flex-col items-center justify-between w-full h-auto max-w-md p-6 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl">
                  <Dialog.Title
                    as="h3"
                    className="dark:text-white-darkMode w-full p-3 mb-3 text-lg font-medium leading-6 text-center text-gray-700 border-b"
                  >
                    ¿Quieres cerrar la sesión?
                  </Dialog.Title>

                  <p className="my-6 text-sm text-center text-gray-500">
                    Si continua deberá a volver a ingresar para ver su
                    información
                  </p>

                  <div className="flex flex-col w-full">
                    <button
                      type="button"
                      className="bg-orange-primary dark:bg-orange-darkMode hover:opacity-80 focus:outline-none focus-visible:ring-2 focus-visible:ring-orange-500 focus-visible:ring-offset-2 inline-flex justify-center px-4 py-2 text-sm font-medium text-white border border-transparent rounded-md"
                      onClick={handleClick}
                    >
                      Cerrar Sesión
                    </button>
                    <button
                      type="button"
                      className="dark:bg-black-darkMode text-payne-primary hover:opacity-80 inline-flex justify-center px-4 py-2 mt-2 text-sm font-medium bg-white rounded-md"
                      onClick={closeModal}
                    >
                      Cancelar
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  )
}
